export interface IInventoryEquipmentOption {
  id?: number;
  name?: string;
  description?: string;
  equipmentKeyId?: number;
  inventoryTemplateId?: string;
}
